module.exports = __webpack_public_path__ + "static/media/client-ui-health.87e80a1c.png";